// extracted by mini-css-extract-plugin
export default {"roomscene":"RoomScene_roomscene__uq7Ao","active":"RoomScene_active__zjPTT"};